import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

function injectCSS(path) {
    path = regionRelativeUrl(path, true);

    let link = document.createElement("link");
    link.href = path;
    link.type = "text/css";
    link.rel = "stylesheet";

    document.getElementsByTagName("head")[0].appendChild(link);
}

export default injectCSS;
